import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./components/Login";
import Register from "./components/Register";
import ForgotPassword from "./components/ForgotPassword";
import Hero from "./components/Hero";
import TopBar from "./components/Navigation/TopBar";
import AllProducts from "./components/Products/AllProducts";
import ProuductDetails from "./components/Products/ProductDetails";
import TermsAndConditions from "./components/Auth/TermsAndConditions";
import ResetPassword from "./components/ResetPassword";
import Profile from "./components/profile/Profile";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Cart from "./components/Cart/Cart";
import AdminProfile from "./components/profile/Admin/AdminProfile";
import Dashboard from "./components/AdminScreen/dashboard";
import Products from "./components/AdminScreen/products/Products";
import Analytics from "./components/AdminScreen/Analytics";
import Orders from "./components/AdminScreen/products/Orders";
import AddProduct from "./components/AdminScreen/products/AddProduct";
import Liked from "./components/profile/Liked";
import AdminProductDetails from "./components/AdminScreen/products/AdminProductDetails";
import Footer from "./components/Footer/Footer";
import { useEffect } from "react";
import {
  getFeatureProduct,
  getWishList,
} from "./redux/features/product/productSlice";
import { useDispatch } from "react-redux";
import Success from "./components/Cart/Success";
import Cancel from "./components/Cart/Cancel";
// import EditProduct from "./components/AdminScreen/products/EditProduct";
import Edit from "./components/AdminScreen/products/Edit";
import OrderDetails from "./components/profile/OrderDetails";
function App() {
  const dispatch = useDispatch(); // Initialize useDispatch

  useEffect(() => {
    // Dispatch the getFeatureProduct action using useDispatch
    dispatch(getWishList());
    dispatch(getFeatureProduct());
  }, [dispatch]); // Include dispatch in the dependency array to ensure it's only called once

  return (
    <>
      <div className="bg-slate-200 pb-20 md:pb-0">
        <Router>
          <div className="">
            <TopBar />
            <Routes>
              <Route path="/" element={<Hero />} />
              <Route
                path="/products/details/:id"
                element={<ProuductDetails />}
              />
              <Route path="/profile" element={<Profile />} />
              <Route path="/profile/order/:id" element={<OrderDetails />} />
              <Route path="/profile/liked" element={<Liked />} />

              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route
                path="/reset-password/:resettoken"
                element={<ResetPassword />}
              />
              <Route path="/cart" element={<Cart />} />
              <Route path="/success" element={<Success />} />
              <Route path="/cancel" element={<Cancel />} />
              <Route path="/admin" element={<Dashboard />} />
              <Route path="/admin/products" element={<Products />} />
              <Route
                path="/admin/products/:id"
                element={<AdminProductDetails />}
              />
              <Route path="/edit-product/:id" element={<Edit />} />
              <Route path="/admin/analytics" element={<Analytics />} />
              <Route path="/admin/orders" element={<Orders />} />
              <Route path="/admin/addproduct" element={<AddProduct />} />
              <Route
                path="/termsandcondition"
                element={<TermsAndConditions />}
              />
              <Route path="/products" element={<AllProducts />} />
              <Route path="/products/:cat" element={<AllProducts />} />
            </Routes>

            <Footer />
          </div>
        </Router>
      </div>
      <ToastContainer />
    </>
  );
}

export default App;
